import request from '@/utils/request'
export function getPage(condition, pagination) {
    return request({
      url: "/crm/base/purchase/page",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  
  export function saveOrUpdate(data) {
    return request({
      url: "/crm/base/purchase/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/crm/base/purchase/get",
      method: "get",
      params: { id },
    });
  }
  
  export function deleteById(id) {
    return request({
      url: "/crm/base/purchase/deleteById",
      method: "post",
      data: { id: id },
    });
  }